import React, { Component } from 'react';
import { observer } from 'mobx-react';

import FilterDisplayHeader from 'app/components/filters/display/FilterDisplayHeader';

@observer
class FilterConnectorDisplay extends Component {
  render() {
    const { group } = this.props;
    const connector = group.connector.getValue();
    const shouldExcludeResults = group.not.getValue();

    return (
      <FilterDisplayHeader excluded={shouldExcludeResults}>
        {shouldExcludeResults ? 'Exclude' : 'Include'} results matching {connector.toLowerCase()} of the following
      </FilterDisplayHeader>
    );
  }
}

export default FilterConnectorDisplay;
